import React from "react"; 
import { getUserData } from "../auth";
import { useGetBalanceQuery } from "../apis/BalanceApi";
  
const BalanceWalletCustomerAmazon = () => {
   
  const userData = getUserData();
  const userId = userData?.uid || "";
  const { data: balanceData, isLoading:isLoadingBalance, error:errorBalance } = useGetBalanceQuery(userId, { pollingInterval: 5000 });
  // Fetch data from PaymentApi using the useGetPaymentQuery hook
  
  const myBalance = balanceData ? balanceData :
  {
    id: 0,
    balance:0
  }
  if (isLoadingBalance) {
    return <div>Loading...</div>;
  }

  if (errorBalance) {
    return <div>Error loading Balance</div>;
  } 

  return (
    <section className="account py-15">
      <div className="container container-lg">
        <div className="row gy-4">
        <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 mt-2">
          {/* Balance Balance Input */}
         <h6>My Balance ${myBalance?.balance}</h6>
         </div>
         </div>
      </div>
    </section>
  );
};

export default BalanceWalletCustomerAmazon;
